// src/contexts/AccessContext.js
import React, { createContext, useContext } from 'react';
import { canAccessTool, getAccessibleTools } from '../config/roles';
import { useAuth } from './AuthContext';

const AccessContext = createContext(null);

export function AccessProvider({ children }) {
  const { isSuperAdmin, isStudent, isDean, allowedTools } = useAuth();

  // The user object shape expected by roles.js helpers
  const userAccess = { isSuperAdmin, isStudent, isDean, allowedTools };

  return (
    <AccessContext.Provider value={{
      canAccessTool: (toolId) => canAccessTool(toolId, userAccess),
      getAccessibleTools: () => getAccessibleTools(userAccess),
    }}>
      {children}
    </AccessContext.Provider>
  );
}

export const useAccess = () => useContext(AccessContext);